import React, { useState } from 'react'
import AuthLayout from '../../components/AuthLayout/AuthLayout'
import { useParams } from 'react-router-dom'
import { ConsumerOrderDetails } from '../../model'
import ConfirmOrderVerify from './ConfirmOrderVerify'
import ConfirmOrderConfirm from './ConfirmOrderConfirm'

const ConfirmOrder: React.FunctionComponent = () => {
    const [step, setStep] = useState<'verify' | 'confirm' | 'done'>('verify')
    const [orderData, setOrderData] = useState<ConsumerOrderDetails>()

    const { token } = useParams<{ token?: string }>()

    return (
        <AuthLayout hideDemoButton iconBackground={false} centerVertical={false} noTopPadding={true}>
            <div className='rounded-xl bg-white border p-8 text-left text-[--tb-text] max-w-[600px] w-full shadow-lg relative z-20 space-y-8'>
                {step === 'verify' && (
                    <ConfirmOrderVerify
                        token={token}
                        onVerified={(data) => {
                            setOrderData(data)
                            setStep('confirm')
                        }}
                    />
                )}
                {step === 'confirm' && orderData && (
                    <ConfirmOrderConfirm
                        token={token}
                        initialOrderData={orderData}
                        onConfirmed={(_data) => {
                            setStep('done')
                        }}
                    />
                )}

                {step === 'done' && (
                    <div className='text-center'>
                        <h2 className='mb-4'>Bedankt voor je bevestiging!</h2>
                        <p className='text-sm text-[--tb-textLight]'>
                            Je ontvangt de factuur per e-mail. Deze browsertab kun je nu gerust sluiten.
                        </p>
                    </div>
                )}
            </div>
        </AuthLayout>
    )
}
export default ConfirmOrder
